import { Role } from "./role.interface";
import { User } from "./user.interface";
import { Workgroup } from "./workgroup.interface";

export interface WorkgroupUser {
    C_WorkgroupUser_key: number;
    C_Workgroup_key: number;
    C_User_key: string;
    C_ClimbRole_key: number;
    StudyAdministrator: boolean | null;
    CreatedBy: string;
    ModifiedBy: string;
    DateCreated: Date;
    DateModified: Date;
    Version: number;
    User: User;
    Workgroup: Workgroup;
    ClimbRole: Role;
}
